import React from "react";

interface ChipProps {
  label: string;
  color: string;
  backgroundColor: string;
  style?: any;
}
const Chip = ({ label, color, backgroundColor, style }: ChipProps) => {
  return (
    <div
      className="staus_chip"
      style={{
        ...style,
        color,
        backgroundColor,
        padding: "5px 10px",
        borderRadius: "8px",
        fontWeight: 500,
        display: "inline-block",
        fontSize: "12px",
      }}
    >
      {label}
    </div>
  );
};

export default Chip;
